import React, { Component, Fragment } from 'react';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { localize } from 'react-localize-redux';

import Header from 'components/shared/Header';
import MenuItem from 'material-ui/MenuItem';

import OutlinedSelect from 'helpers/reduxFormMaterialUiNext/OutlinedSelect';
import * as validator from 'helpers/Validator';

const styles = {
  tableWrapper: {
    position: 'relative',
  },
};

class ShowingRestrictionsForm extends Component {
  render() {
    return (
      <Fragment>
        <div style={styles.tableWrapper}>
          {this._renderShowingLengthSelector()}
          {this._renderShowingCadenceSelector()}
          <Header
            name={this.translateText(
              'landlordPortal.amenities.restrictions.customizeBookingBufferTime'
            )}
          />
          <div className="row" style={{ padding: '15px' }}>
            <p style={{ textAlign: 'justify' }}>
              {this.translateText('landlordPortal.amenities.restrictions.bufferTimeDescription')}
            </p>
            <div className="col-xs-12" style={{ paddingLeft: 0 }}>
              {this._bufferFields(
                'booking_buffer_time_in_minutes',
                this.translateText('landlordPortal.amenities.restrictions.select')
              )}
            </div>
          </div>

          <div className="row" style={{ padding: '15px' }}>
            <p style={{ textAlign: 'justify' }}>
              {this.translateText(
                'landlordPortal.amenities.restrictions.bufferBetweenTimeDescription'
              )}
            </p>
            <div className="col-xs-12" style={{ paddingLeft: 0 }}>
              {this._bufferFields(
                'booking_buffer_time_between_in_minutes',
                this.translateText('landlordPortal.amenities.restrictions.select')
              )}
            </div>
          </div>
        </div>
      </Fragment>
    );
  }

  _bufferFields = (fieldName, label) => (
    <Field
      fullWidth
      name={fieldName}
      component={OutlinedSelect}
      label={label}
      validate={[validator.required]}
    >
      <MenuItem key={`start_time_0`} value="0">
        {this.translateText('landlordPortal.amenities.restrictions.none')}
      </MenuItem>
      <MenuItem key={`start_time_30`} value="30">
        30 {this.translateText('landlordPortal.amenities.restrictions.minutes')}
      </MenuItem>
      <MenuItem key={`start_time_60`} value="60">
        1 {this.translateText('landlordPortal.amenities.restrictions.hour')}
      </MenuItem>
      {[2, 4, 8, 12, 24].map(i => (
        <MenuItem key={`restriction_options_${i}`} value={i * 60}>
          {i} {this.translateText('landlordPortal.amenities.restrictions.hour')}s
        </MenuItem>
      ))}
    </Field>
  );

  translateText = text => this.props.translate(text).props.children;

  showingLengths = [
    {
      value: 15,
      label: `15 ${this.translateText('landlordPortal.showingRestrictionsForm.minutes')}`,
    },
    {
      value: 30,
      label: `30 ${this.translateText('landlordPortal.showingRestrictionsForm.minutes')}`,
    },
    {
      value: 45,
      label: `45 ${this.translateText('landlordPortal.showingRestrictionsForm.minutes')}`,
    },
    {
      value: 60,
      label: `60 ${this.translateText('landlordPortal.showingRestrictionsForm.minutes')}`,
    },
    {
      value: 75,
      label: `75 ${this.translateText('landlordPortal.showingRestrictionsForm.minutes')}`,
    },
  ];

  showingCadences = [
    {
      value: 15,
      label: `15 ${this.translateText('landlordPortal.showingRestrictionsForm.minutes')}`,
    },
    {
      value: 30,
      label: `30 ${this.translateText('landlordPortal.showingRestrictionsForm.minutes')}`,
    },
    {
      value: 45,
      label: `45 ${this.translateText('landlordPortal.showingRestrictionsForm.minutes')}`,
    },
    {
      value: 60,
      label: `60 ${this.translateText('landlordPortal.showingRestrictionsForm.minutes')}`,
    },
  ];

  _renderShowingLengthSelector = () => {
    return (
      <Fragment>
        <Header name={this.translateText('landlordPortal.showingRestrictionsForm.showingLength')} />
        <div className="row" style={{ padding: '15px' }}>
          <p style={{ textAlign: 'justify' }}>
            {this.translateText('landlordPortal.showingRestrictionsForm.youCanSelect')}
          </p>
          <div className="col-xs-12" style={{ paddingLeft: 0 }}>
            <Field
              fullWidth
              name="showing_length"
              component={OutlinedSelect}
              label={this.translateText('landlordPortal.showingRestrictionsForm.showingLength')}
              validate={[validator.required]}
            >
              {this.showingLengths.map(option => (
                <MenuItem key={`start_time_${option}`} value={option.value}>
                  {' '}
                  {option.label}{' '}
                </MenuItem>
              ))}
            </Field>
          </div>
        </div>
      </Fragment>
    );
  };

  _renderShowingCadenceSelector = () => {
    return (
      <Fragment>
        <Header name={this.translateText('landlordPortal.amenities.restrictions.showingCadence')} />
        <div className="row" style={{ padding: '15px' }}>
          <p style={{ textAlign: 'justify' }}>
            {this.translateText('landlordPortal.amenities.restrictions.showingCadenceDescription')}
          </p>
          <div className="col-xs-12" style={{ paddingLeft: 0 }}>
            <Field
              fullWidth
              name="desired_booking_intervals"
              component={OutlinedSelect}
              label={this.translateText('landlordPortal.amenities.restrictions.showingCadence')}
              validate={[validator.required]}
            >
              {this.showingCadences.map(option => (
                <MenuItem key={`start_time_${option}`} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </Field>
          </div>
        </div>
      </Fragment>
    );
  };
}

ShowingRestrictionsForm = compose(
  connect((_, ownProps) => {
    return {
      form: ownProps.formName,
    };
  }),
  reduxForm({
    destroyOnUnmount: true,
    forceUnregisterOnUnmount: true,
    enableReinitialize: true,
  })
)(ShowingRestrictionsForm);

export default localize()(ShowingRestrictionsForm);
